import React, { useState, useEffect } from "react";

const TypingAnimation = () => {
  const roles = [
    "Full-Stack Developer",
    "React Developer",
    "Problem Solver",
    "Code Enthusiast",
  ];

  const [currentRoleIndex, setCurrentRoleIndex] = useState(0);
  const [currentText, setCurrentText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const currentRole = roles?.[currentRoleIndex];

    const timeout = setTimeout(
      () => {
        if (isPaused) {
          setIsPaused(false);
          setIsDeleting(true);
          return;
        }

        if (isDeleting) {
          setCurrentText(currentRole?.substring(0, currentText?.length - 1));

          if (currentText === "") {
            setIsDeleting(false);
            setCurrentRoleIndex((prev) => (prev + 1) % roles?.length);
          }
        } else {
          setCurrentText(currentRole?.substring(0, currentText?.length + 1));

          if (currentText === currentRole) {
            setIsPaused(true);
          }
        }
      },
      isDeleting ? 50 : isPaused ? 2000 : 100
    );

    return () => clearTimeout(timeout);
  }, [currentText, isDeleting, isPaused, currentRoleIndex, roles]);

  return (
    <div className="relative">
      <span className="text-conversion-accent font-mono">
        {currentText}
        <span className="cursor-blink text-conversion-accent">|</span>
      </span>
    </div>
  );
};

export default TypingAnimation;
